module.exports = __webpack_public_path__ + "static/media/test11_3.e4fe2bb7.png";